import React, {PureComponent} from "react"
import {connect} from "react-redux"
import {Row, Col} from "react-bootstrap"

import {DealCategory} from "@irati/types"
import id from "@irati/utils/id"
import {Label} from "@irati/ui/src/Typography"
import tracking from "@irati-tracking/perks/perks"

import ImageRouterLink from "../ImageRouterLink"
import TagRouterLink from "./styled/TagRouterLink"

interface OptionalProps {
  className?: string
}

interface Props extends OptionalProps {
  categories: DealCategory[]
  mq: {
    lessThan: {
      md: boolean
    }
  }
}

class TopCategories extends PureComponent<Props> {
  renderTagLinks(categories: DealCategory[], idNamespace: string) {
    return categories.map((category) => {
      const linkProps = this.generateLinkProps(category, idNamespace)

      return (
        <TagRouterLink key={category.uuid} {...linkProps} plain>
          {category.name}
        </TagRouterLink>
      )
    })
  }

  generateLinkProps(category: DealCategory, idNamespace: string) {
    return {
      id: id(`link--${category.uuid}`, idNamespace, {prefix: "categories"}),
      to: `/categories/${category.url}`
    }
  }

  topCategoryClicked(category: DealCategory, index: number) {
    tracking.topCategoryTileClicked(category, index)
  }

  renderImageLinks(categories: DealCategory[], idNamespace: string) {
    return (
      <Row>
        {categories.map((category, index) => {
          const linkProps = this.generateLinkProps(category, idNamespace)

          return (
            <Col sm={3} key={category.uuid}>
              <ImageRouterLink {...linkProps} image={category.image} onClick={() => this.topCategoryClicked(category, index)}>
                <Label large color="white" uppercase>
                  {category.name}
                </Label>
              </ImageRouterLink>
            </Col>
          )
        })}
      </Row>
    )
  }

  render() {
    const {categories, mq, className} = this.props
    const idNamespace = id("top-categories", this.props)
    const isMobile = mq.lessThan.md

    return (
      <div className={className}>
        {isMobile && this.renderTagLinks(categories, idNamespace)}
        {!isMobile && this.renderImageLinks(categories, idNamespace)}
      </div>
    )
  }
}

const mapStateToProps = ({mq}: Props) => ({mq})

export default connect(mapStateToProps)(TopCategories)
